export default __webpack_public_path__ + "static/media/9.56e031c7.jpg";